import { Box, Button, Stack, Typography } from '@mui/material';

import history from 'src/services/routing/history';
import { routePaths } from 'src/services/routing/routePaths';

import { styles } from './index.styles';

const CatchNullURL = () => (
  <Stack direction="column" sx={{ height: '100vh' }}>
    <Box sx={styles.catchNullUrl}>
      <Typography variant="h2">
        Single sign-on for getReport is not supported by your browser version.
      </Typography>

      <Typography variant="body1" sx={{ py: 5 }}>
        We recommend to use either Chrome or Firefox. Alternatively, you may use
        the “Get new password” button to login with your e-mail-address and
        password.
      </Typography>

      <Button
        variant="cta"
        onClick={() => history.push(routePaths.LOGIN)}
        sx={styles.takeMeBackButton}
      >
        Back to login
      </Button>
    </Box>
  </Stack>
);

export default CatchNullURL;
